import { render, staticRenderFns } from "./FactItem.vue?vue&type=template&id=63e0dc28&functional=true&"
import script from "./FactItem.vue?vue&type=script&lang=js&"
export * from "./FactItem.vue?vue&type=script&lang=js&"
import style0 from "./FactItem.vue?vue&type=style&index=0&id=63e0dc28&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports